import 'magnific-popup';

export default function (obj) {
    obj.find('.herald-image-format').magnificPopup({
        type: 'image',
        image: {
            titleSrc: function titleSrc(item) {
                return item.el.find('figure').text();
            }
        }
    });
}
